/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import { handleClientContactForm } from "./client_contact";
// import { handleClientBtnStyle } from "./client_button";
import { handleClientFooter } from "./client_footer";
import { handleClientIconBox } from "./client_icon_box";
import { handleClientPageAnimation } from "./client_page-animation";
import { addGAEvent } from "./gaEvent";
// import { handleMobileCustomHeader } from "./custom_header";
import { handleBlogPostClick, handleInsightBackBtn } from "./insight";
import { createParentEventHandler } from "./share_with_external";

jQuery(function(){
    handleBlogPostClick();
    handleInsightBackBtn();
    createParentEventHandler();
    handleClientFooter();
    // handleMobileCustomHeader();
    // handleClientBtnStyle();
    // handleClientIconBox();
    handleClientPageAnimation();
    handleClientContactForm();
    addGAEvent();
}); // end of: jQuery(function()

function start(){
    
}

start();

